module.exports = __webpack_public_path__ + "assets/img/share-icon-3.1f6dde2b.png";